import React from "react";
import axios from "axios";
import SideMenu from "../components/SideMenu";
import PaymentSuccess from "../components/PaymentSuccess";

const Dashboard = ({ user, showSuccess, setShowSuccess }) => {
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [activeDirectories, setActiveDirectories] = React.useState([]);
  const [freeDirectories, setFreeDirectories] = React.useState([]);
  const [paidDirectories, setPaidDirectories] = React.useState([]);
  const [trustedDirectories, setTrustedDirectories] = React.useState([]);
  const [nicheDirectories, setNicheDirectories] = React.useState([]);

  React.useEffect(() => {
    if (user) {
      const fetchData = async () => {
        setLoading(true);
        const result = await axios.get(
          "https://www.api.webdirectories.info/api/listing/get-by-user/" +
            user._id
        );
        setData(result.data);
        setActiveDirectories(
          result.data.filter((item) => item.status === "Approved")
        );
        setTrustedDirectories(
          result.data.filter((item) => item.listingType === "Trusted")
        );
        setNicheDirectories(
          result.data.filter((item) => item.listingType === "Niche")
        );
        setPaidDirectories(
          result.data.filter((item) => item.listingType === "Paid")
        );
        setFreeDirectories(
          result.data.filter((item) => item.listingType === "Free")
        );
        setLoading(false);
      };
      fetchData();
    }
  }, [user]);

  if (showSuccess)
    return (
      <PaymentSuccess
        showSuccess={showSuccess}
        setShowSuccess={setShowSuccess}
      />
    );

  return (
    <div>
      <div className="container">
        <div className="row flex-nowrap">
          <SideMenu profilePic={user?.profilePic} />
          <div className="col py-3">
            <div>
              <h1>Welcome : {user?.name}</h1>
            </div>
            <div class="mt-5">
              <div class="dashboard-header-stats">
                <div class="swiper-container swiper-container-initialized swiper-container-horizontal">
                  <div class="swiper-wrapper">
                    <div className="row">
                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Total Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">{data?.length}</h5>
                        </div>
                      </div>
                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Active Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">
                            {activeDirectories?.length}
                          </h5>
                        </div>
                      </div>

                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Free Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">{freeDirectories?.length}</h5>
                        </div>
                      </div>
                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Paid Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">{paidDirectories?.length}</h5>
                        </div>
                      </div>
                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Trusted Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">
                            {trustedDirectories?.length}
                          </h5>
                        </div>
                      </div>
                      <div class="coll-3 coll-sm-6 card bg-light">
                        <div class="card-header">Niche Directories</div>
                        <div class="card-body">
                          <h5 class="card-title">{nicheDirectories?.length}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-5">
              <p>
                <strong>Name:</strong>
                {user?.name}
              </p>
              <p>
                <strong>Display Name:</strong> {user?.name}
              </p>
              <p>
                <strong>Registered Email:</strong> {user?.email}
              </p>
              <p>
                <strong>Phone No:</strong> {user?.phone}
              </p>
              <p>
                <strong>Address: </strong> {user?.address}
              </p>
              <p>
                <strong>Website:</strong> {user?.website}
              </p>
              <p>
                <strong>Company:</strong> {user?.company}
              </p>
              <p>
                <strong> Description:</strong> {user?.desc}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
